<template>
  <div class="d-flex flex-grow-1 align-items-center text-center">
    <p class="mt0 mb40 fz22">{{viewData.text}}</p>
  </div>
</template>

<script>
  import editMixin from '../../mixins/editMixin';

  export default {
    name: "EditText",
    mixins: [editMixin]
  }
</script>

<style scoped>

</style>